<template>
  <div>
    <expansion v-model="isExpanded">
        <template slot="default">
          <section class="menu-option">
            <div style="width: 12px">
              <expanded-icon :isExpanded="isExpanded"/>
            </div>
            <span class="_titleFormFont pb-3">{{ this.label }}</span>
          </section>
        </template>

        <template slot="expanded">
          <div ref="section" v-mutate="checkIsEmpty">
            <slot></slot>
          </div>
          <slot v-if="isEmpty" name="noContent"></slot>
        </template>
    </expansion>
    <hr v-if="divider" class="_divider"/>
  </div>
</template>

<script>
import Expansion from '../ui/Expansion.vue'
import AddBtn from '../ui/AddBtn.vue'
import ExpandedIcon from './ExpandedIcon.vue'

export default {
  name: 'FormSection',
  components: {Expansion, AddBtn, ExpandedIcon},
  props: {
    value: {type: Boolean, required: true},
    label: {type: String, default: 'Menu expansivel'},
    divider: {type: Boolean, default: true}
  },
  computed: {
    isExpanded: {
      get () { return this.value},
      set (v) { this.$emit('input', v) }
    }
  },

  data: () => ({
    isEmpty: false
  }),

  mounted () {
    this.checkIsEmpty()
  },

  methods: {
    checkIsEmpty () {
      if (this.isExpanded === false || Object.keys(this.$slots).length === 0) return false

      const isDefaultSlotOnlyText = !this.$slots.default[0].tag && this.$slots.default[0].text
      const isSomeHtmlTag = this.$slots.default[0].tag && !this.$slots.default[0].tag.includes('vue-component')
      if (isDefaultSlotOnlyText || isSomeHtmlTag) {
        this.isEmpty = false
        return
      }

      const sectionRef = this.$refs.section
      const sectionChildrens = sectionRef.children[0].children.length
      if (sectionChildrens === 0) this.isEmpty = true
      else this.isEmpty = false
    }
  }
}
</script>

<style scoped>
  .menu-option {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    color: #24252D
  }

  .menu-option h3 {
    flex: 1;
    font-size: 16px;
    font-weight: 700;
  }

  .divider {
    margin: 24px 8px 16px 8px;
    border: none;
    height: 1px;
    background-color: rgba(102, 109, 128, 0.1);
  }    
</style>